import { ExerciseState } from "@/models";

export const icons = {
	[ExerciseState.DRAFT]: ["insert_drive_file-sm"],
	[ExerciseState.PUBLIC]: ["public-sm"],
	[ExerciseState.PRIVATE]: ["visibility_off-sm"],
};
